<td>Remote Pilot In Command</td>
<td *ngIf="!selectPerson">
    <div class="horizontal-container vertical-align space-between">
        <div class="horizontal-container">
            <action-required *ngIf="rpicNotAvailable"
                >This person is no longer available for the
                role</action-required
            >
            <a
                *ngIf="crewLookup && crewLookup[rpicId] != null"
                (click)="showPersonDetails.emit(rpicId)"
                >{{ crewLookup ? crewLookup[rpicId] : '' }}
            </a>
            <span *ngIf="crewLookup && crewLookup[rpicId] == null"
                >Unknown Person</span
            >
        </div>
        <button
            type="button"
            class="btn btn-tertiary"
            tooltip="Select a different person"
            placement="top"
            (click)="selectPerson = !selectPerson"
            [disabled]="disable || readonly"
        >
            <span class="fal fa-pencil-alt"></span>
        </button>
    </div>
</td>
<td *ngIf="selectPerson">
    <div class="horizontal-container vertical-align">
        <ng-select
            [items]="pilots"
            [(ngModel)]="rpicId"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="disable || readonly"
            [clearable]="false"
            bindValue="id"
            placeholder="Select a person"
            groupBy="registerWithWorkgroupStatus"
            (change)="onUpdate()"
            appendTo="body"
            class="wide-panel fill"
            [loading]="loadingPersonnel"
            [virtualScroll]="true"
            (scrollToEnd)="onPilotSelectScroll()"
            (search)="onPilotSelectSearch($event)"
            (close)="onPilotSelectClose()"
        >
            <ng-template ng-label-tmp let-item="item">
                {{ item | formatPerson }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-index="index">
                {{ item | formatPerson }}
            </ng-template>
        </ng-select>
        <button
            *ngIf="rpicId != null"
            type="button"
            class="btn btn-tertiary no-margin"
            tooltip="Cancel"
            placement="top"
            (click)="selectPerson = !selectPerson"
            [disabled]="disable || readonly"
        >
            <span class="fal fa-times"></span>
        </button>
    </div>
</td>
<ng-container
    *ngIf="
        showStatus &&
        !pilotRegisterDisabled &&
        !isLoading &&
        getPilotRegisterStatus(rpicId) as status
    "
    [ngSwitch]="status"
>
    <td *ngFor="let id of authorityIds">
        <span *ngSwitchCase="null"></span>
        <span *ngIf="registerEntriesOnMissionLoading">Loading...</span>
        <span *ngSwitchDefault>
            <ng-container *ngIf="!registerEntriesOnMissionLoading">
                <pilot-register-details-overall-status
                    [pilotId]="rpicId"
                    [status]="status[id] ? status[id] : 'N/A'"
                    [authorityId]="id"
                ></pilot-register-details-overall-status>
                <button
                    *ngIf="hasRpa && status[id] && status[id] !== 'N/A'"
                    type="button"
                    class="btn btn-tertiary"
                    (click)="toggleShowPilotRegisterDetails()"
                >
                    <span
                        class="fa"
                        [ngClass]="{
                            'fa-chevron-down': !showRpicRegisterDetails,
                            'fa-chevron-up': showRpicRegisterDetails
                        }"
                        [tooltip]="
                            (showRpicRegisterDetails ? 'Hide ' : 'Show more ') +
                            'register status information'
                        "
                        placement="top"
                    ></span>
                </button>
            </ng-container>
        </span>
    </td>
</ng-container>
<ng-container *ngIf="showStatus && (pilotRegisterDisabled || !rpicId)">
    <ng-container *ngIf="!isLoading">
        <td>
            {{ pilotRegisterDisabled || rpicId ? 'N/A' : '' }}
        </td>
    </ng-container>
    <ng-container *ngIf="isLoading">
        <td>Loading...</td>
    </ng-container>
</ng-container>
<td>
    <button
        type="button"
        class="btn btn-tertiary btn-delete"
        (click)="deleteRow()"
        [disabled]="disable || readonly"
    >
        <span class="fal fa-trash-alt"></span>
    </button>
</td>
